import { useEffect, useState } from "react";
import {
  getAllCategories,
  createCategory as apiCreateCategory,
  getCategoryById,
  updateCategory as apiUpdateCategory,
  deleteCategory as apiDeleteCategory,
  createPostFormTemplate as apiCreatePostFormTemplate,
  getPostFormTemplate,
  updatePostFormTemplate as apiUpdatePostFormTemplate,
  deletePostFormTemplate as apiDeletePostFormTemplate,
} from "../admin/api/Categories";

export const useCategories = () => {
  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const loadCategories = async () => {
      try {
        const data = await getAllCategories();
        setCategories(data);
      } catch (err) {
        setError(err);
      } finally {
        setLoading(false);
      }
    };
    loadCategories();
  }, []);

  // Wrapped functions to accept token
  const createCategory = async (category, token) => {
    return await apiCreateCategory(category, token);
  };
  const updateCategory = async (categoryId, category, token) => {
    return await apiUpdateCategory(categoryId, category, token);
  };
  const deleteCategory = async (categoryId, token) => {
    return await apiDeleteCategory(categoryId, token);
  };
  const createPostFormTemplate = async (categoryId, formTemplate, token) => {
    return await apiCreatePostFormTemplate(categoryId, formTemplate, token);
  };
  const updatePostFormTemplate = async (categoryId, formTemplate, token) => {
    return await apiUpdatePostFormTemplate(categoryId, formTemplate, token);
  };
  const deletePostFormTemplate = async (categoryId, token) => {
    return await apiDeletePostFormTemplate(categoryId, token);
  };

  return {
    categories,
    loading,
    error,
    createCategory,
    updateCategory,
    deleteCategory,
    getCategoryById,
    createPostFormTemplate,
    getPostFormTemplate,
    updatePostFormTemplate,
    deletePostFormTemplate,
  };
};
